import { render, staticRenderFns } from "./EmailFavorites.vue?vue&type=template&id=8f604e7e&scoped=true&"
import script from "./EmailFavorites.vue?vue&type=script&lang=ts&"
export * from "./EmailFavorites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f604e7e",
  null
  
)

export default component.exports